// extracted by mini-css-extract-plugin
export default {"wrap":"Benefits_wrap__m29us","image":"Benefits_image__C2yEz","content":"Benefits_content__oyVbS","title":"Benefits_title__4-gUm","list":"Benefits_list__jDfMT"};